import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

import { CroppedFilePayload } from "core/http/service/accountInfo/paramsTypes";

interface InitialState {
  status: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {},
};

const changeAvatarSlice = createSlice({
  name: "changeAvatar",
  initialState,
  reducers: {
    changeAvatarStart: (state, action: PayloadAction<CroppedFilePayload>) => {
      state.status = ReduxStateType.LOADING;
    },
    changeAvatarSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    changeAvatarFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const { changeAvatarStart, changeAvatarSuccess, changeAvatarFailed } =
  changeAvatarSlice.actions;

export default changeAvatarSlice.reducer;
